import LoginComponent from "../MVPComponents/LoginComponent";

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default Login;
